import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DashboardRoutes = defineRoute({
    home: {
        route: {
            path: "/",
            component: () => loadView(import("./DashboardHome.vue")),
        },
    },
});
